import React, { useEffect, useState } from "react";
import axios from "axios";
import { checkIfUserIsLoggined } from "../../utils/utils.js";
import Header from "../Header";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Footer from '../Footer';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useBasketStore } from '../../store/Basket';
import { useNotificationsStore } from '../../store/Notifications';
import Basket from '../Basket';
import OrdersTab from './UserPersonalCabinet/OrdersTab';
import DiscountTab from './UserPersonalCabinet/DiscountTab';
import FavoritesTab from './UserPersonalCabinet/FavoritesTab';
import NotificationsTab from './UserPersonalCabinet/NotificationsTab';
import ProfileTab from './UserPersonalCabinet/ProfileTab';
import PromoCodesTab from './UserPersonalCabinet/PromoCodesTab';
import '../../styles/personal-cabinet.css';

const UserPersonalCabinetPage = props => {
  const history = useHistory();
  const location = useLocation();

  // Мапінг між URL параметрами та eventKey (вкладка "Сповіщення" показується лише при notificationsCount > 0)
  const tabToEventKey = {
    'profile': 'profile',
    'promos': 'promos',
    'orders': 'first',
    'discount': 'second',
    'favorites': 'third',
    'notifications': 'fourth'
  };

  const eventKeyToTab = {
    'profile': 'profile',
    'promos': 'promos',
    'first': 'orders',
    'second': 'discount',
    'third': 'favorites',
    'fourth': 'notifications'
  };

  // Визначаємо активний таб з URL або використовуємо дефолтний
  const getActiveTab = () => {
    const currentQueryParams = queryString.parse(location.search);
    if (currentQueryParams.tab && tabToEventKey[currentQueryParams.tab]) {
      return tabToEventKey[currentQueryParams.tab];
    }
    return 'profile'; // дефолтний таб
  };

  let [activeTab, setActiveTab] = useState(() => {
    const currentQueryParams = queryString.parse(location.search);
    if (currentQueryParams.tab && tabToEventKey[currentQueryParams.tab]) {
      return tabToEventKey[currentQueryParams.tab];
    }
    return 'profile';
  });
  let [orders, setOrders] = useState([]);
  let [user, setUser] = useState({});
  const [notificationsTotal, setNotificationsTotal] = useState(0);
  const [notificationsUnread, setNotificationsUnread] = useState(0);
  const [notificationsCountLoaded, setNotificationsCountLoaded] = useState(false);
  const addProductToCart = useBasketStore(state => state.addProduct);
  const cartProducts = useBasketStore(state => state.products);
  const [productIdsInCart, setProductIdsInCart] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const Toggle = () => setShowModal(!showModal);

  // Оновлюємо активний таб при зміні URL параметрів
  useEffect(() => {
    const newActiveTab = getActiveTab();
    if (newActiveTab !== activeTab) {
      setActiveTab(newActiveTab);
      window.scrollTo(0, 0);
    }
  }, [location.search]);

  // Встановлюємо дефолтний таб в URL, якщо його немає
  useEffect(() => {
    const currentQueryParams = queryString.parse(location.search);
    if (!currentQueryParams.tab) {
      history.replace(`/user/personal-cabinet?tab=profile`);
    }
  }, []);

  const refetchUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios
      .get('/api/v1/auth/current-user', { headers: { Authorization: token } })
      .then(res => {
        if (res.status === 200) setUser(res.data.data);
      })
      .catch(() => {});
  };

  // Якщо відкрито таб "Сповіщення", але сповіщень немає (після завантаження лічильника) — переходимо на замовлення
  useEffect(() => {
    const currentQueryParams = queryString.parse(location.search);
    if (notificationsCountLoaded && currentQueryParams.tab === 'notifications' && notificationsTotal === 0 && isLoggedIn) {
      history.replace(`/user/personal-cabinet?tab=orders`);
      setActiveTab('first');
    }
  }, [notificationsTotal, notificationsCountLoaded, isLoggedIn, location.search]);


  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("token");
    if (!token) {
      checkIfUserIsLoggined(props);
      return;
    }
    const url = activeTab === 'second'
      ? "/api/v1/auth/current-user?getAdditionalDiscountInfo=true"
      : "/api/v1/auth/current-user";
    axios
      .get(url, {
        headers: { Authorization: token }
      })
      .then(res => {
        if (res.status === 200) {
          setUser(res.data.data);
          setIsLoggedIn(true);
        } else {
          props.history.push("/login");
        }
      })
      .catch(() => {
        props.history.push("/login");
      });
    axios
      .get("/api/v1/user/order", {
        headers: { Authorization: token }
      })
      .then(res => {
        setOrders(res.data.data);
      })
      .catch(() => {
        props.history.push("/login");
      });
    axios
      .get("/api/v1/user/notifications/count", { headers: { Authorization: token } })
      .then(res => {
        if (res.data && res.data.data) {
          const d = res.data.data;
          if (typeof d.total === 'number') setNotificationsTotal(d.total);
          if (typeof d.unread === 'number') {
            setNotificationsUnread(d.unread);
            useNotificationsStore.getState().setNotificationsUnread(d.unread);
          }
        }
        setNotificationsCountLoaded(true);
      })
      .catch(() => {
        setNotificationsTotal(0);
        setNotificationsUnread(0);
        useNotificationsStore.getState().setNotificationsUnread(0);
        setNotificationsCountLoaded(true);
      });
  }, [activeTab]);

  useEffect(() => {
    const productIdsInCart = cartProducts.map(product => product.id);
    setProductIdsInCart(productIdsInCart);
  }, [cartProducts]);

  return (
    <div className="container">
      <Helmet>
        <title>Персональний кабінет</title>
      </Helmet>
      <div className="row">
        <div className="col p-0 pb-3">
          <Header />
        </div>
      </div>

      <div className='row'>
        <div className='col p-0 pb-3'>
          <Tab.Container id='left-tabs-example' activeKey={activeTab} onSelect={(eventKey) => {
            setActiveTab(eventKey);
            const tab = eventKeyToTab[eventKey];
            history.push(`/user/personal-cabinet?tab=${tab}`);
            window.scrollTo(0, 0);
          }}>
            <Row>
              <Col sm={2}>
                <Nav variant='pills' className='flex-column black-text'>
                  <Nav.Item>
                    <Nav.Link eventKey='profile'>Профіль</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='first'>Мої замовлення</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='second'>Персональна знижка</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='promos'>Мої промокоди</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='third'>Обрані товари</Nav.Link>
                  </Nav.Item>
                  {notificationsTotal > 0 && (
                    <Nav.Item>
                      <Nav.Link eventKey='fourth'>
                        Сповіщення
                        {notificationsUnread > 0 && (
                          <span className="ml-1 badge badge-primary">{notificationsUnread}</span>
                        )}
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
                <hr className="h-divider pb-3"/>
              </Col>
              <Col sm={10}>
                <Tab.Content>
                  <Tab.Pane eventKey='profile'>
                    <ProfileTab user={user} onProfileSaved={refetchUser} />
                  </Tab.Pane>
                  <Tab.Pane eventKey='first'>
                    <OrdersTab orders={orders} />
                  </Tab.Pane>

                  <Tab.Pane eventKey='second'>
                    <DiscountTab user={user} props={props} />
                  </Tab.Pane>

                  <Tab.Pane eventKey='promos'>
                    <PromoCodesTab active={activeTab === 'promos' && isLoggedIn} />
                  </Tab.Pane>

                  <Tab.Pane eventKey='third'>
                    <FavoritesTab 
                      history={history} 
                      props={props} 
                      productIdsInCart={productIdsInCart}
                      onToggleModal={Toggle}
                      addProductToCart={addProductToCart}
                    />
                  </Tab.Pane>
                  {notificationsTotal > 0 && (
                    <Tab.Pane eventKey='fourth'>
                      <NotificationsTab onCountChange={(counts) => {
                        if (!counts) return;
                        if (typeof counts.total === 'number') setNotificationsTotal(counts.total);
                        if (typeof counts.unread === 'number') {
                          setNotificationsUnread(counts.unread);
                          useNotificationsStore.getState().setNotificationsUnread(counts.unread);
                        }
                      }} />
                    </Tab.Pane>
                  )}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>

      <div className="row">
        <div className="col p-0">
          <Footer />
        </div>
      </div>
      <Basket showModal={showModal} close={Toggle} />
    </div>
  );
}

export default UserPersonalCabinetPage;
